import { MODULE_PLATFORMS } from '../types/module.js';
const PLATFORM_SET = new Set(MODULE_PLATFORMS);
function isPlatform(value) {
    return typeof value === 'string' && PLATFORM_SET.has(value);
}
/**
 * Absent or empty → `['console']`. **Only** reader of `Module.platforms`
 * (request 0151 §1.2) — no consumer may read the field directly.
 */
export function modulePlatforms(mod) {
    const raw = mod.platforms;
    if (!Array.isArray(raw) || raw.length === 0)
        return ['console'];
    const valid = raw.filter(isPlatform);
    if (valid.length === 0)
        return ['console'];
    return [...new Set(valid)].sort((a, b) => a.localeCompare(b));
}
/** Whether the module has a programmed screen on the given platform. */
export function runsOn(mod, platform) {
    return modulePlatforms(mod).includes(platform);
}
/**
 * Write-path normalizer: keeps only `MODULE_PLATFORMS` values, dedupes, sorts.
 * Empty / invalid → `undefined` (persisted as absent = default console on read).
 */
export function normalizePlatforms(raw) {
    if (raw == null)
        return undefined;
    let items;
    if (Array.isArray(raw)) {
        items = raw;
    }
    else if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (!trimmed)
            return undefined;
        items = trimmed.split(/[,;]+/);
    }
    else {
        return undefined;
    }
    const seen = new Set();
    const result = [];
    for (const item of items) {
        const value = typeof item === 'string' ? item.trim() : item;
        if (!isPlatform(value) || seen.has(value))
            continue;
        seen.add(value);
        result.push(value);
    }
    if (result.length === 0)
        return undefined;
    return result.sort((a, b) => a.localeCompare(b));
}
//# sourceMappingURL=modulePlatforms.js.map